import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const exportToExcel = (exportedData: any[], fileName: string) => {
  const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const ws = XLSX.utils.json_to_sheet(exportedData);
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: excelFileType });
  FileSaver.saveAs(data, fileName);
}

const ExportService = {
  exportToExcel,
};

export default ExportService;
